import httpRequest from '../request/indexBase'

const perModuleType = '1'

// 查询未分类文件列表
export function queryUnCategorizedFiles(perFolderId = '') {
  return httpRequest.get({
    url: `/file/queryUnclassiAigcFilesSize`,
    params: {
      perFolderId,
      perModuleType
    }
  })
}

// 查询文件夹列表
export function queryFolderList(params, perFolderId = '') {
  return httpRequest.get({
    url: `/aigcDam/aigc-folder/getAigcFolderListByParentId`,
    params: {
      ...params,
      perFolderId,
      perModuleType
    }
  })
}

// 查询文件夹最近使用列表-前10
export function getRecentlyUsedFolderList(params) {
  return httpRequest.get({
    url: `/user/recently-used-folder/getRecentlyUsedFolderList`,
    params
  })
}

// 查询文件夹协作者
export function queryFolderCollaborators(params, perFolderId = '') {
  return httpRequest.get({
    url: `/permission/team-data-permission/getDataPermissionList`,
    params: {
      ...params,
      perFolderId,
      perModuleType
    }
  })
}

// 查询文件夹协作者（不包含归属者）
export function queryFolderCollaboratorsNotCreate(params, perFolderId = '') {
  return httpRequest.get({
    url: `/permission/team-data-permission/getDataPermission`,
    params: {
      ...params,
      perFolderId,
      perModuleType
    }
  })
}

// 管理文件夹协作者
export function manageFolderCollaborators(data) {
  return httpRequest.put({
    url: `/permission/team-data-permission/updateDataPermission`,

    data
  })
}

// 编辑单个文件夹协作者
export function editSingleFolderCollaborator(data) {
  return httpRequest.put({
    url: `/permission/team-data-permission/updateUserPermission`,

    data
  })
}

// 查询用户文件夹的查看权限
export function queryFolderPermissions(params, perFolderId = '') {
  return httpRequest.get({
    url: `/permission/team-data-permission/getUserDataPermission`,
    params: {
      ...params,
      perFolderId,
      perModuleType
    }
  })
}

//新增文件夹
export function createFolder(data, perFolderId = '') {
  return httpRequest.post({
    url: '/aigcDam/aigc-folder/saveAigcFolder',
    params: {
      perFolderId,
      perModuleType
    },
    data
  })
}

//文件夹排序
export function sortFolders(data, perFolderId = '') {
  return httpRequest.put({
    url: '/aigcDam/aigc-folder/updateBatchAigcFolder',
    params: {
      perFolderId,
      perModuleType
    },
    data
  })
}

//下载资源
export function downloadResource(data, perFolderId = '') {
  return httpRequest.post({
    url: '/weaviate/report-brain-dir',
    params: {
      perFolderId,
      perModuleType
    },
    data
  })
}

//编辑文件夹
export function editFolder(data, perFolderId = '') {
  return httpRequest.put({
    url: '/aigcDam/aigc-folder/updateFolderInfo',
    params: {
      perFolderId,
      perModuleType
    },
    data
  })
}

//文件夹移动
export function moveFolder(data, perFolderId = '') {
  return httpRequest.post({
    url: '/aigcDam/aigc-folder/moveAigcFolder',
    params: {
      perFolderId,
      perModuleType
    },
    data
  })
}

//文件夹复制
export function copyFolder(data, perFolderId = '') {
  return httpRequest.post({
    url: '/aigcDam/aigc-folder/copyAigcFolder',
    params: {
      perFolderId,
      perModuleType
    },
    data
  })
}

//删除文件夹
export function deleteFolder(data, perFolderId = '') {
  return httpRequest.put({
    url: '/aigcDam/aigc-folder/deleteAigcFolder',
    params: {
      perFolderId,
      perModuleType
    },
    data
  })
}

//案例详情查询  todo
export function queryCaseDetails(params, perFolderId = '') {
  return httpRequest.get({
    url: `/file/open/${params.id}`,
    params: {
      perFolderId,
      perModuleType
    }
  })
}

//编辑案例
export function editCase(data, perFolderId = '') {
  return httpRequest.put({
    url: '/file',
    params: {
      perFolderId,
      perModuleType
    },
    data
  })
}

//编辑案例提示词
export function editCasePrompt(data, perFolderId = '') {
  return httpRequest.put({
    url: '/file/updateFilesPrompt',
    params: {
      perFolderId,
      perModuleType
    },
    data
  })
}

// 创建分享链接
export function createShareLink(data) {
  return httpRequest.post({
    url: `/share/save`,
    data
  })
}

// 删除分享链接
export function deleteShareLink(params) {
  return httpRequest.delete({
    url: `/share`,
    params
  })
}

// 查询分享链接详情
export function queryShareLinkDetails(shareCode, data) {
  return httpRequest.post({
    url: `/share/get/${shareCode}`,
    data
  })
}

// 分享资源下载
export function downloadSharedResource(data, perFolderId = '') {
  return httpRequest.post({
    url: `/weaviate/crawled-report/page`,
    params: {
      perFolderId,
      perModuleType
    },
    data
  })
}

// 转存到知识库
export function saveToKnowledgeBase(data, perFolderId = '') {
  return httpRequest.post({
    url: `/file/copy`,
    params: {
      perFolderId,
      perModuleType,
      teamId: data.teamId,
      ownerType: data.ownerType
    },
    data
  })
}

// 转存到知识库（从图片生成）
export function saveToKnowledgeBaseImg(data, perFolderId = '') {
  return httpRequest.post({
    url: `/file/saveFromChatRecord`,
    params: {
      perFolderId,
      perModuleType,
      teamId: data.teamId,
      ownerType: data.ownerType
    },
    data
  })
}

// 云空间查询
export function queryCloudSpace(params) {
  return httpRequest.get({
    url: `/repository/data-cloud-space/getCloudSpace`,
    params
  })
}

// 查询模块权限列表
export function queryModulePermissions(params) {
  return httpRequest.get({
    url: `/permission/data-permission/getSystemDataPermissionList`,
    params
  })
}

// 查询模块权限列表
export function saveUploadAigcFiles(data, perFolderId) {
  return httpRequest.post({
    url: `/file/saveUploadAigcFiles`,
    params: {
      perFolderId,
      perModuleType
    },
    data
  })
}

export function fileUpload(data, perFolderId = '') {
  return httpRequest.post({
    url: '/repository/files-record/fileUpload',
    data: data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}

// 查询解析状态
export function getAnalyzeStatus(params, perFolderId = '') {
  return httpRequest.get({
    url: `/file/getSpellAnalysisStatus`,
    params: {
      ...params,
      perFolderId,
      perModuleType
    }
  })
}

//提示词解析
export function analyzePrompt(data, perFolderId = '') {
  return httpRequest.post({
    url: '/file/spellAnalysisPicture',
    data: data,
    params: {
      perFolderId,
      perModuleType
    }
  })
}

// 知识库查询解析状态
export function databaseGetAnalyzeStatus(params, perFolderId = '') {
  return httpRequest.get({
    url: `/weaviate/data-library-detail/getSpellAnalysisBaseStatus`,
    params: {
      ...params,
      perFolderId,
      perModuleType: '0'
    }
  })
}

// 知识库提示词解析
export function databaseAnalyzePrompt(data, perFolderId = '') {
  return httpRequest.post({
    url: '/weaviate/data-library-detail/spellAnalysisBasePicture',
    data: data,
    params: {
      perFolderId,
      perModuleType: '0'
    }
  })
}
